// Datas de AULA (agenda, aula experimental, aula extra) são horário de parede
// da escola (São Paulo). A API as manda como "yyyy-MM-dd HH:mm", sem fuso; as
// mais antigas vinham como Date cru, "yyyy-MM-ddTHH:mm:ss.sssZ", em que o "Z"
// NÃO é UTC de verdade: 20:00Z significa 20h em São Paulo.
//
// `new Date(valor)` + getHours() deslocava essas datas 3h para trás no
// navegador (retorno de 08/10 do card 86aje36nz: aula das 20h aparecia como
// 17h). Aqui os números são lidos como estão, sem conversão de fuso.
const WALL_CLOCK =
  /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]00:?00)?$/;

export function parseSchoolWallClock(value) {
  if (!value) return null;
  const match = WALL_CLOCK.exec(String(value).trim());
  if (!match) return null;

  const [, year, month, day, hour, minute] = match;
  // Mesmo horário no relógio do navegador -- para comparar com "agora" quem
  // está no fuso da escola.
  const local = new Date(+year, +month - 1, +day, +hour, +minute, 0, 0);
  if (Number.isNaN(local.getTime())) return null;

  return { year, month, day, hour, minute, local };
}
